import script from "./AdministratorProjectFormStep2.vue?vue&type=script&setup=true&lang=js"
export * from "./AdministratorProjectFormStep2.vue?vue&type=script&setup=true&lang=js"

import "./AdministratorProjectFormStep2.vue?vue&type=style&index=0&id=673028f4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-673028f4"]])

export default __exports__